module.exports = __webpack_public_path__ + "media/conmex/peticiones-bf018353.png";